module.exports = __webpack_public_path__ + "img/i-dice-mono.3d79db1c.svg";